/**
 * Printing a sheet (checklist or report) from the browser. The app's screens scroll inside a
 * fixed-height window, so a plain print shows only what fits on screen: one page. Before
 * printing, this marks the sheet's surroundings so that, on paper only, everything around the
 * sheet disappears and the sheet flows over as many pages as it needs, its lists in columns.
 * It changes nothing on screen.
 */
const PRINT_CSS = `
@media print {
  @page { margin: 0.5in; }
  html, body { height: auto !important; overflow: visible !important; background: #fff !important; }
  [data-print-hide] { display: none !important; }
  [data-print-path] { height: auto !important; min-height: 0 !important; max-height: none !important; overflow: visible !important;
    position: static !important; flex: none !important; transform: none !important; padding: 0 !important; margin: 0 !important;
    width: auto !important; max-width: none !important; display: block !important; }
  #print-sheet { box-shadow: none !important; border-radius: 0 !important; padding: 0 !important; width: auto !important; max-width: none !important; }
  #print-columns { display: block !important; column-width: 2.1in; column-gap: 0.3in; }
  #print-columns-wide { display: block !important; column-width: 3.4in; column-gap: 0.35in; }
  #print-columns > *, #print-columns-wide > * { break-inside: avoid; }
  #print-products > * { width: 25% !important; }
}`;

export function printSheet() {
  if (!document.getElementById('print-css')) {
    const style = document.createElement('style');
    style.id = 'print-css';
    style.textContent = PRINT_CSS;
    document.head.appendChild(style);
  }
  for (const el of document.querySelectorAll('[data-print-hide],[data-print-path]')) {
    el.removeAttribute('data-print-hide');
    el.removeAttribute('data-print-path');
  }
  const sheet = document.getElementById('print-sheet');
  if (!sheet) return window.print();
  // Every container from the sheet up to the page keeps only the branch that leads to the sheet.
  for (let node: HTMLElement | null = sheet.parentElement; node && node !== document.body; node = node.parentElement) {
    node.setAttribute('data-print-path', '');
    for (const sibling of Array.from(node.children)) {
      if (!sibling.contains(sheet) && sibling.tagName !== 'STYLE') sibling.setAttribute('data-print-hide', '');
    }
  }
  for (const sibling of Array.from(sheet.parentElement?.children ?? [])) {
    if (sibling !== sheet) sibling.setAttribute('data-print-hide', '');
  }
  window.print();
}
